// extracted by mini-css-extract-plugin
export default {"product-summary-wrapper":"Detail_product-summary-wrapper__Y0lrU","item":"Detail_item__2xRUP"};